import { memo } from "react";

function PickupStopMarker(props) {
  const { stopNo,
    backgroundColor,
    borderColor,
    textColor,
    size } = props;
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -3;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1"
        width={size - 3}
        height={size - 2}
        rx="1.5"
        fill={backgroundColor}
        stroke={borderColor}
        strokeWidth={1}
      />
        <text
          id={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontSize={10}
          fontWeight={500}
          fill={textColor}
        >
          <tspan x={8 + shiftLeft} y={15}>
            {props.stopNo}
          </tspan>
        </text>
    </svg>
  );
}

export default memo(PickupStopMarker);
